export const BRIGHTNESS_RULES = {
    // 基本亮度规则
    BASIC_BRIGHTNESS: {
        condition: (global, _partitions) => {
            const rules = [];

            if (global.brightness.level === "DARK") {
                if (global.brightness.dynamicRange === "COMPLETE") {
                    rules.push("darkComplete");
                } else if (global.brightness.dynamicRange === "LIMITED") {
                    rules.push("darkLimited");
                } else if (global.brightness.dynamicRange === "PARTIAL") {
                    rules.push("darkPartial");
                }
            } else if (global.brightness.level === "BRIGHT") {
                if (global.brightness.dynamicRange === "COMPLETE") {
                    rules.push("brightComplete");
                } else if (global.brightness.dynamicRange === "LIMITED") {
                    rules.push("brightLimited");
                } else if (global.brightness.dynamicRange === "PARTIAL") {
                    rules.push("brightPartial");
                }
            } else if (global.brightness.level === "NEUTRAL") {
                if (global.brightness.dynamicRange === "COMPLETE") {
                    rules.push("neutralComplete");
                } else if (global.brightness.dynamicRange === "LIMITED") {
                    rules.push("neutralLimited");
                } else if (global.brightness.dynamicRange === "PARTIAL") {
                    rules.push("neutralPartial");
                }
            }

            return rules;
        }
    },

    // 突出特征规则
    FEATURE_RULES: {
        condition: (global, partitions) => {
            const features = [];

            // 高对比特征：明暗动态范围为 COMPLETE，且暗部和高光层次明确
            if (global.brightness.dynamicRange === "COMPLETE" &&
                partitions.blacks?.brightness?.statistics?.mean <= 30 &&
                partitions.highlights?.brightness?.statistics?.mean >= 180) {
                features.push("highContrast");
            }

            // 低调特征：暗部占主导，阴影和中间调均层次集中
            if (global.brightness.level === "DARK" &&
                partitions.shadows?.brightness?.statistics?.stdDev < 10 &&
                partitions.midtones?.brightness?.statistics?.stdDev < 20) {
                features.push("lowKey");
            }

            // 高调特征：亮部占主导，高光和中间调均为 BRIGHT 且层次分布较集中
            if (global.brightness.level === "BRIGHT" &&
                partitions.highlights?.brightness?.statistics?.mean >= 190 &&
                partitions.midtones?.brightness?.statistics?.mean >= 120) {
                features.push("highKey");
            }

            return features;
        }
    },

    // // 相邻分区关系规则
    // SMOOTH_SHADOW_TRANSITION: {
    //     condition: (global, partitions) =>
    //         partitions.blacks?.brightness?.statistics?.mean != null &&
    //         partitions.shadows?.brightness?.statistics?.mean != null &&
    //         Math.abs(partitions.blacks.brightness.statistics.mean - 
    //                 partitions.shadows.brightness.statistics.mean) < 30 &&
    //         partitions.shadows.brightness.level === "DARK"
    // },
    // GRADUAL_MIDTONE_TRANSITION: {
    //     condition: (global, partitions) =>
    //         partitions.shadows?.brightness?.statistics?.mean != null &&
    //         partitions.midtones?.brightness?.statistics?.mean != null &&
    //         partitions.highlights?.brightness?.statistics?.mean != null &&
    //         Math.abs(partitions.shadows.brightness.statistics.mean - 
    //                 partitions.midtones.brightness.statistics.mean) < 30 &&
    //         Math.abs(partitions.midtones.brightness.statistics.mean - 
    //                 partitions.highlights.brightness.statistics.mean) < 30
    // },

    // // 调区占比规则
    // MIDTONE_BIASED: {
    //     condition: (global, partitions) =>
    //         partitions.midtones?.brightness?.statistics?.percentage > 50 &&
    //         partitions.midtones.brightness.level === "NEUTRAL"
    // },
    // BALANCED_DISTRIBUTION: {
    //     condition: (global, partitions) =>
    //         partitions.shadows?.brightness?.statistics?.percentage != null &&
    //         partitions.highlights?.brightness?.statistics?.percentage != null &&
    //         partitions.midtones?.brightness?.statistics?.percentage != null &&
    //         Math.abs(partitions.shadows.brightness.statistics.percentage - 
    //                 partitions.highlights.brightness.statistics.percentage) < 10 &&
    //         partitions.midtones.brightness.statistics.percentage > 30
    // },

    // 细节特征
    DETAIL_FEATURES: {
        condition: (partitions) => {
            const details = [];
            const { blacks, shadows, highlights, whites } = partitions;

            // 暗部细节丰富规则
            if (blacks?.brightness?.statistics?.stdDev > 5 &&
                shadows?.brightness?.statistics?.stdDev > 8) {
                details.push("richShadowDetail");
            }

            // 高光细节控制规则
            if (highlights?.brightness?.statistics?.stdDev > 8 &&
                whites?.brightness?.statistics?.stdDev > 5) {
                details.push("wellControlledHighlight");
            }

            return details;
        }
    },
    // 分区特征规则
    PARTITION_FEATURES: {
        condition: (partitions) => {
            const features = [];
            const { blacks, shadows, highlights, whites, midtones } = partitions;

            // 暗部特征规则
            if ((blacks?.brightness?.dynamicRange !== "LIMITED" && blacks?.brightness?.dynamicRange != null) ||
                (shadows?.brightness?.dynamicRange !== "LIMITED" && shadows?.brightness?.dynamicRange != null)) {
                features.push("richShadow");
            } else if (blacks?.brightness?.level === "DARK" || shadows?.brightness?.level === "DARK") {
                features.push("concentratedShadow");
            }

            // 高光特征规则
            if ((highlights?.brightness?.dynamicRange !== "LIMITED" && highlights?.brightness?.dynamicRange != null) ||
                (whites?.brightness?.dynamicRange !== "LIMITED" && whites?.brightness?.dynamicRange != null)) {
                features.push("richHighlight");
            } else if (highlights?.brightness?.level === "BRIGHT" || whites?.brightness?.level === "BRIGHT") {
                features.push("brightHighlight");
            }

            // 中间调特征规则
            if (midtones?.brightness?.dynamicRange === "LIMITED") {
                features.push("compressedMidtone");
            } else if (midtones?.brightness?.dynamicRange === "COMPLETE") {
                features.push("balancedMidtone");
            }

            return features;
        }
    },
};